const DISCOUNTS_QUERY = `
discounts {
  discountId
  conditions {
    type
    value
  }
  discountValue
  discountType
  fromDate
  toDate
}`;

export const getCitiesQuery = mustRequestDiscounts => `
  cities {
    id
    currencyIsoCode
  }
  currentCity: cities(cityIds: [$cityId]) {
    id
    areaId
    currencyIsoCode
    maximumPrice
    country {
      countryIsoCode
    }
    center {
      lng
      lat
    }
    limits {
      sw {
        lng
        lat
      }
      ne {
        lng
        lat
      }
    }
    minimumStaying
    otherCitiesInCountry
    allCities
    ${mustRequestDiscounts ? DISCOUNTS_QUERY : ''}
  }
`;
